import React, { useState, useEffect } from "react";
import rotateScreenGif from "../assets/images/rotate-screen.gif";

const OrientationCheck = () => {
  const [isPortrait, setIsPortrait] = useState(
    window.innerHeight > window.innerWidth
  );

  const handleResize = () => {
    setIsPortrait(window.innerHeight > window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize); // for mobile devices

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);

  return (
    <>
      {isPortrait && (
        <div className="portrait-mode-overlay">
          <img src={rotateScreenGif} alt="" />
        </div>
      )}
    </>
  );
};

export default OrientationCheck;
